var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-empty"},[_c('x-svg-icon',{staticClass:"empty-icon",attrs:{"name":"x-lib-empty"}}),(_vm.$slots.default)?[_vm._t("default")]:_c('span',{staticClass:"empty-text"},[_vm._v("暂无数据")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }